import { ImageWrapper, LinkWrapper, RevealBlock } from "@/pages/help/components/MdxElements.tsx";
import { tableTheme } from "@skailer-com/uikit";
import { MDXComponents } from "mdx/types";
import { twMerge } from "tailwind-merge";

export const mdxComponents: MDXComponents = {
  img: ImageWrapper,
  a: LinkWrapper,
  blockquote: ({ children }) => {
    return <div className={twMerge("px-6 py-4 mt-2 mb-4 rounded-sm bg-dark/5")}>{children}</div>;
  },
  table: ({ children }) => (
    <div className={"w-full overflow-x-auto mb-6"}>
      <table className={twMerge(tableTheme.base, "min-w-0")}>{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className={tableTheme.table.thead.base}>{children}</thead>,
  th: (props) => <th {...props} className={tableTheme.table.thead.th} />,
  tr: ({ children }) => <tr className={tableTheme.table.tbody.tr}>{children}</tr>,
  td: (props) => <td {...props} className={tableTheme.table.tbody.td} />,
  Reveal: RevealBlock,
};
